import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-apple-pay-payment-method',
  templateUrl: './apple-pay.component.html',
  styleUrls: ['./apple-pay.component.scss']
})
export class ApplePayComponent implements OnInit {
  public link:string;
  private lock: boolean = false;
  private session:Session;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "card/apple-pay";
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });

  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("apple-pay");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","apple_pay");
    if(event!=undefined&&!this.lock){
      this.sessionService.setCurrencyCodeListLock(false);
      this.sessionService.emitSelectedPaymentMethod("apple-pay");
      // this.router.navigate(['card/add'], { skipLocationChange: true, relativeTo: this.route } ).then(() => {
        this.router.navigate([this.link], {relativeTo: this.route});
      // });
    }
    // this.router.navigate([this.link],{relativeTo: this.route});

  }
}
